import * as utils from '@/utils';

export default {
  data() {
	return {
	  currentScrollTop: 0
	};
  },
  mounted() {
	this.onScroll = utils.debounce(this.scrollHandler);
	window.addEventListener('scroll', this.onScroll);
  },
  methods: {
	scrollHandler() {
	  this.currentScrollTop = (document.scrollingElement || document.documentElement).scrollTop;
	  sessionStorage.setItem('scrollY', this.currentScrollTop);
	}
  },

  beforeDestroy() {
	window.removeEventListener('scroll', this.onScroll);
  }
};
